function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M48 0H0v48h48V0z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#logo-small_svg__a)",
  fill: "#008FD5"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.179 47.54C36.887 47.54 48 36.898 48 23.77 48 10.643 36.887 0 23.18 0 14.557 0 6.963 4.212 2.513 10.603c3.734-3.92 9.11-6.38 15.088-6.38 11.274 0 20.414 8.753 20.414 19.55 0 10.796-9.14 19.548-20.414 19.548-5.977 0-11.353-2.46-15.088-6.38 4.45 6.39 12.044 10.602 20.666 10.602v-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.018 40.066C7.62 40.066.002 32.769.002 23.769S7.62 7.474 17.018 7.474c5.912 0 11.119 2.887 14.169 7.267-2.56-2.687-6.246-4.374-10.344-4.374-7.729 0-13.995 6-13.995 13.402 0 7.403 6.266 13.403 13.995 13.403 4.098 0 7.784-1.687 10.344-4.374-3.05 4.38-8.258 7.267-14.169 7.267v.002z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.16 24.456l1.244.301c-.26.978-.73 1.725-1.41 2.241-.675.512-1.502.767-2.481.767-1.013 0-1.838-.196-2.475-.589-.633-.397-1.115-.97-1.449-1.719a5.93 5.93 0 01-.494-2.413c0-.937.186-1.754.558-2.45.377-.7.909-1.23 1.597-1.59a4.826 4.826 0 012.282-.546c.94 0 1.731.23 2.372.688.641.458 1.088 1.103 1.34 1.934l-1.224.276c-.218-.655-.535-1.132-.95-1.43-.414-.3-.935-.449-1.564-.449-.722 0-1.327.166-1.814.498a2.642 2.642 0 00-1.02 1.338 5.143 5.143 0 00-.294 1.725c0 .765.115 1.435.346 2.008.235.569.598.994 1.09 1.277a3.151 3.151 0 001.596.423c.697 0 1.287-.192 1.77-.577.483-.384.81-.956.98-1.713zm2.847 3.156v-9h6.34v1.062h-5.096v2.787h4.41v1.062h-4.41v4.09h-1.244zm14.669-3.156l1.244.301c-.261.978-.731 1.725-1.41 2.241-.676.512-1.503.767-2.482.767-1.013 0-1.838-.196-2.475-.589-.632-.397-1.115-.97-1.449-1.719a5.931 5.931 0 01-.493-2.413c0-.937.186-1.754.557-2.45.377-.7.909-1.23 1.597-1.59a4.826 4.826 0 012.282-.546c.94 0 1.731.23 2.372.688.641.458 1.088 1.103 1.34 1.934l-1.224.276c-.218-.655-.535-1.132-.95-1.43-.414-.3-.935-.449-1.563-.449-.723 0-1.327.166-1.815.498a2.641 2.641 0 00-1.02 1.338 5.143 5.143 0 00-.294 1.725c0 .765.115 1.435.346 2.008.235.569.598.994 1.09 1.277a3.151 3.151 0 001.596.423c.697 0 1.287-.192 1.77-.577.483-.384.81-.956.98-1.713z"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "logo-small_svg__clip0_1_2"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v48H0z"
})));

var SvgLogoSmall = function SvgLogoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-small_svg__clip0_1_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "logo-small_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _ref), _ref2), _ref3);
};

export default SvgLogoSmall;